import type { decalageEncaissement as Fr } from '../fr/decalageEncaissement';

/** "1 rental", "3 rentals". */
const rentals = (n: number) => `${n} ${n === 1 ? 'rental' : 'rentals'}`;

/** « decalageEncaissement » in English — typed on the French: a missing sentence does not compile. */
export const decalageEncaissement: typeof Fr = {
  localeMois: 'en-GB',
  locationsDuMois: (n, nom) => (n === 1 ? `1 ${nom} rental` : `${n} rentals in ${nom}`),
  ou: {
    caisse: (nom) => `in the ${nom} cash register`,
    banque: (nom) => `at the bank (received in ${nom})`,
    mixte: (nom, m) => `in the ${nom} cash register, of which ${m} at the bank`,
  },
  notes: {
    dont: 'Of which ',
    avance: (pour) => ` collected in advance for ${pour}.`,
    retard: (pour) => ` received this month for ${pour}.`,
    annulee: ' on a rental cancelled since.',
    banque: ' at the bank (cheque, transfer), not in the drawer.',
    dejaAvant: (mois, n) => `Already collected in ${mois} for ${rentals(n)} this month: `,
    dejaApres: (ou) => ` — ${ou}, not in this one.`,
    plusTardAvant: (mois, n) => `Collected later, in ${mois}, for ${rentals(n)} this month: `,
    plusTardApres: (ou) => ` — ${ou}.`,
  },
  dontBanque: (m) => ` (of which ${m} at the bank)`,
  voirVoitureEn: (mois) => `See this vehicle in ${mois}`,
  ouvrirCaisseDe: (nom) => `Open the ${nom} cash register`,
  pour: (pour) => `For ${pour}: `,
  encaissesEn: (mois) => `Collected in ${mois}: `,
  virguleOu: (ou) => `, ${ou}.`,
  avance: {
    titre: (m) => `${m} collected in advance this month`,
    texte: (plusieurs) => `This money came in this month, but it pays for ${plusieurs
      ? 'rentals that will take place later'
      : 'a rental that will take place later'}.`,
  },
  deja: {
    titre: (m) => `${m} for this month was collected in an earlier month`,
    texte: (plusieurs) => `${plusieurs
      ? 'Some rentals this month were paid in advance.'
      : 'A rental this month was paid in advance.'} This money is not counted here: it is in the month it was received.`,
  },
  retard: { titre: (m) => `${m} received this month for rentals from previous months` },
  plusTard: { titre: (m) => `${m} for this month was collected later` },
  annulee: {
    titre: (m) => `${m} collected on a rental cancelled since`,
    texte: 'The rental was cancelled, but the money received stays in the month that received it.',
  },
};
